import { ICurrentUser, IReadOptions } from '@samc/common';
import { PageListCachedDataSource } from '@/Sources/BaseDataSources';
import { IUserData } from '@samc/taskmanagement-ui';

export class WorkflowTemplateUserDataSource extends PageListCachedDataSource<IUserData> {
  public constructor() {
    super('/datasource/users');
  }

  public async loadData(options: IReadOptions, abortController: AbortController): Promise<IUserData[]> {
    const data: ICurrentUser[] = (await super.loadData(options, abortController)) as any[];
    
    // Hardcoded users that should always be included
    const hardcodedUsers: IUserData[] = [
      { username: 'Analyst', email: 'Analyst' },
      { username: 'Trader', email: 'Trader' },
      { username: 'Transaction Manager', email: 'Transaction Manager' },
      { username: 'Salesperson', email: 'Salesperson' },
    ];
  
    const fetchedUsers: IUserData[] = data.map(user => ({
      username: user.name,
      email: user.email
    } as IUserData)).sort((a, b) => a.username.localeCompare(b.username));
  
    return [...hardcodedUsers, ...fetchedUsers];
  }
}